
import { Component, VModel } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ObservationMixin from '@/_mixins/observation'

@Component({
    mixins: [ObservationMixin],
    inheritAttrs: false,
})
export default class ReporterIsNullFilter extends Mixins<MixinInterface>(ObservationMixin) {
    @VModel() filter!: null | boolean
}
